import { FASTElement } from "@microsoft/fast-element";
import { CSSDesignToken, DesignToken } from "../foundation/design-token";
import { DesignTokenValue } from "../foundation/design-token-node";

export class NatGenDesignToken<T extends string | number | boolean | BigInteger | null | Array<any> | symbol | {}> {
    defaultValue: DesignTokenValue<T>;
    name: string;
    token: CSSDesignToken<T>;

    constructor(init?: Partial<NatGenDesignToken<T>>) {
        Object.assign(this, init);
    }

    static factory<T>(name: string, factory: (token: NatGenDesignToken<T>) => NatGenDesignToken<T>) {
        return factory(new NatGenDesignToken<T>({ name }));
    }

    create() {
        this.token = DesignToken.create<T>(this.name).withDefault(this.defaultValue);
    }

    setAlias(target: DesignToken<T>) {
        this.token = DesignToken.create<T>(this.name).withDefault(target);
    }

    setValueFor(element: FASTElement, value: DesignTokenValue<T>) {
        if (this.token == null)
            throw `Token ${this.name} must be created before updated.`;

        this.token.setValueFor(element, value);
    }

    getValueFor(element: FASTElement): T {
        return this.token.getValueFor(element);
    }

    withDefault(value: DesignTokenValue<T>) {
        this.defaultValue = value;

        if (this.token != null)
            this.token.withDefault(value);
    }

    deleteValueFor(element: FASTElement) {
        return this.token?.deleteValueFor(element);
    }
}
